import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Button, EmptyState } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useGetLinks } from 'shared/domains/urls';
/**
 * Default error UI for ScreenLayout.Content. All props are optional — omit any to use the built-in fallback for that slot.
 */
export function ContentErrorState(props) {
    const { icon, title, description, actions } = props;
    const { contact } = useGetLinks();
    return (<Box height="100%" width="100%" alignItems="center" justifyContent="center">
      <EmptyState icon={icon || <Falcon icon="exclamation-circle"/>} title={title || t({ message: 'Error', comment: 'Generic error in content layout' })} description={description || t({ message: 'Something unexpected happened.', comment: 'Generic error in content layout' })} actions={actions || (<Button type="button" appearance="secondary" size="xs" as="a" href={contact} target="_blank" rel="noopener noreferrer">
              <Trans comment="Generic error message in content: Contact support link.">Contact support</Trans>
            </Button>)}/>
    </Box>);
}
